<template>
  <div>
    <v-row class="mx-2">
      <v-col cols="12" md="6" class="flex-items">
        <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
          <v-tab v-for="tab in tabList" :key="tab.id" @click="changeTab(tab)">{{
            tab.name
          }}</v-tab>
        </v-tabs>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" md="6" class="d-flex justify-space-between">
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="search"
          label="Search"
          single-line
          hide-details
          class="rounded-lg"
          color="#239FAB"
          dense
        ></v-text-field>
        <v-btn
          class="white--text ml-2 rounded-lg"
          :color="$vuetify.theme.themes.light.submitBtns"
          @click="add()"
        >
          <v-icon left> mdi-plus-box-outline </v-icon>
          Add New
        </v-btn>
      </v-col>
    </v-row>
    <v-card class="ma-5 dt-container" elevation="0" outlined>
      <v-data-table
        :headers="headers"
        :items="data"
        :items-per-page="10"
        :search="search"
        :options.sync="options"
        :loading="loading"
        @pagination="pagination"
        hide-default-footer
      >
        <template v-slot:[`item.action`]="{ item }">
          <v-btn
            v-if="item.strat_type == 'SUC'"
            class="my-1"
            block
            x-small
            color="blue"
            outlined
            @click="viewSUC(item)"
          >
            Targets
          </v-btn>
          <v-btn
            v-if="viewFrom != 'PresAndVp' && item.strat_type != 'SUC'"
            class="my-1"
            block
            x-small
            color="blue"
            outlined
            @click="viewGoals(item)"
          >
            Goals
          </v-btn>
          <v-btn
            v-if="item.strat_type != 'SUC'"
            class="my-1"
            block
            x-small
            color="green"
            outlined
            @click="viewSummary(item)"
          >
            {{ viewFrom != "PresAndVp" ? "Summary" : "View" }}
          </v-btn>
          <v-btn
            v-if="viewFrom != 'PresAndVp'"
            class="my-1"
            block
            x-small
            color="orange"
            outlined
            @click="update(item)"
          >
            Update
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-row class="mb-2 mx-5" align="center">
      <v-col cols="auto" class="mr-auto text-truncate flex-items" no-gutters>
        <span class="px-2">Show</span>
        <span>
          <v-select
            dense
            outlined
            color="#519043"
            hide-details
            :value="options.itemsPerPage"
            style="max-width: 90px"
            class="rounded-lg"
            @change="options.itemsPerPage = parseInt($event, 10)"
            :items="perPageChoices"
          >
          </v-select>
        </span>
        <span class="px-2"> Entries </span>
      </v-col>

      <v-col cols="auto" class="mr-auto text-truncate" no-gutters>
        Showing {{ paginationData.pageStart + 1 }} to
        {{ paginationData.pageStop }} of
        {{ paginationData.itemsLength }} entries
      </v-col>
      <v-col cols="auto">
        <v-pagination
          v-model="options.page"
          class="rounded-lg"
          :total-visible="7"
          :color="$vuetify.theme.themes.light.submitBtns"
          :length="paginationData.pageCount"
        >
        </v-pagination>
      </v-col>
    </v-row>

    <!-- delete dialog -->
    <v-dialog v-model="confirmDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to delete this information?<br /><br />
              Please note that
              <b>this action is irreversible.</b>
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
            Are you sure you want to proceed?
          </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cancelDelete()">
            Close
          </v-btn>
          <v-btn color="green" class="white--text" @click="confirmDelete()">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AddStrategicPlanningDialog :data="itemData" :action="action" :tab="tab" />

    <ViewSUCDialog :data="sucData" :action="action" />

    <ViewStratPlanSummaryDialog :data="spSumData" :action="action" />
    <viewGoals :data="goalsData" :action="action" />

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="5000"
    ></fade-away-message-component>
  </div>
</template>
<script>
export default {
  props: {
    viewFrom: null,
  },
  components: {
    AddStrategicPlanningDialog: () =>
      import(
        "../../components/Dialogs/Forms/StrategicPlanning/AddStrategicPlanningDialog.vue"
      ),
    ViewSUCDialog: () =>
      import(
        "../../components/Dialogs/Forms/StrategicPlanning/ViewSUCDialog.vue"
      ),

    ViewStratPlanSummaryDialog: () =>
      import(
        "../../components/Dialogs/Forms/StrategicPlanning/ViewStratPlanSummaryDialog.vue"
      ),

    viewGoals: () =>
      import("../../components/Dialogs/Forms/StrategicPlanning/ViewGoals.vue"),
  },
  data: () => ({
    confirmDialog: false,
    itemToDelete: null,
    search: "",
    fullname: null,
    applicantData: null,
    itemData: null,
    taggingData: null,
    spData: null,
    sucData: null,
    spSumData: null,
    goalsData: null,
    supportData: null,
    headers: [
      {
        text: "Title",
        value: "title",
        align: "start",
        valign: "start",
        sortable: false,
      },
      {
        text: "Year From",
        value: "yearFrom",
        align: "center",
        valign: "center",
        sortable: false,
      },
      // {
      //   text: "Strategic Type",
      //   value: "strat_type",
      //   align: "center",
      //   valign: "center",
      //   sortable: false,
      // },
      {
        text: "Year To",
        value: "yearTo",
        align: "center",
        valign: "center",
        sortable: false,
      },

      {
        text: "Action",
        value: "action",
        align: "center",
        width: 100,
        valign: "center",
        sortable: false,
      },
    ],

    data: [],

    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    activeTab: { id: 1, name: "SDP" },
    tab: 1,
    tabList: [
      { id: 1, name: "SDP" },
      { id: 2, name: "SUC Leveling" },
      //   { id: 3, name: "Applicants" },
    ],
    mporData: null,
    ipcr: null,
    mporSumData: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
    yearList: [],
  }),

  mounted() {
    this.eventHub.$on("closeStrategicPriority", () => {
      this.initialize();
    });

    this.eventHub.$on("closeViewSUC", () => {
      this.initialize();
    });
    this.eventHub.$on("closeGoals", () => {
      this.initialize();
    });

    this.eventHub.$on("closeViewStratPlanSummaryDialog", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeStrategicPriority");
    this.eventHub.$off("closeViewSUC");

    this.eventHub.$off("closeGoals");
    this.eventHub.$off("closeViewStratPlanSummaryDialog");
  },
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    filterYear: {
      handler(newData, oldData) {
        if (oldData != newData) {
          this.initialize();
        }
      },
      deep: true,
    },
  },
  computed: {
    filterYear() {
      return this.$store.getters.getFilterSelected;
    },
  },
  methods: {
    getPeriodDescription(id) {
      for (let i = 0; i < this.periodList.length; i++) {
        if (this.periodList[i].id == id) {
          return this.periodList[i].description;
        }
      }
    },
    pagination(data) {
      this.paginationData = data;
    },

    initialize() {
      this.axiosCall(
        "/strategic-planning/getAllStratPlanByType/" + this.tab,
        "GET",
      ).then((res) => {
        if (res) {
          this.data = res.data;
          this.loading = false;
        }
      });
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
    add() {
      this.itemData = { id: null };
      this.action = "Add";
    },

    viewSUC(item) {
      this.sucData = item;
      // this.action = "Update";
    },
    viewGoals(item) {
      this.goalsData = item;
      // this.action = "Update";
    },
    viewSummary(item) {
      this.spSumData = item;
    },

    update(item) {
      this.itemData = item;
      this.action = "Update";
    },

    deleteItem(item) {
      this.itemToDelete = item;
      this.confirmDialog = true;
    },

    // confirmDelete() {
    //   this.axiosCall("/ipcr/" + this.itemToDelete.id, "DELETE").then((res) => {
    //     if (res.data.status == 200) {
    //       this.confirmDialog = false;
    //       this.fadeAwayMessage.show = true;
    //       this.fadeAwayMessage.type = "success";
    //       this.fadeAwayMessage.header = "System Message";
    //       this.fadeAwayMessage.message = res.data.msg;
    //       this.initialize();
    //     } else {
    //       this.fadeAwayMessage.show = true;
    //       this.fadeAwayMessage.type = "error";
    //       this.fadeAwayMessage.header = "System Message";
    //       this.fadeAwayMessage.message = res.data.msg;
    //     }
    //   });
    // },
    // cancelDelete() {
    //   this.itemToDelete = null;
    //   this.confirmDialog = false;
    // },
  },
};
</script>
